import { render, staticRenderFns } from "./configuration-sourcing-details.vue?vue&type=template&id=44f1da55&scoped=true&"
import script from "./js/configuration-sourcing-details.js?vue&type=script&lang=js&"
export * from "./js/configuration-sourcing-details.js?vue&type=script&lang=js&"
import style0 from "./configuration-sourcing-details.vue?vue&type=style&index=0&id=44f1da55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f1da55",
  null
  
)

export default component.exports